import { z } from 'zod';

import { AlertStatusSchema } from '../../../../entities/alert-status';

// Each individual measurement in time
export const TimeseriesPointSchema = z.object({
  timestamp: z.date(),
  value: z.number(),
});
export type TimeseriesPoint = z.infer<typeof TimeseriesPointSchema>;

// A "submetric" line, e.g., "avg" or "min" or "max"
export const TimeseriesSubLineSchema = z.object({
  label: z.string(), // e.g., "avg" | "min" | "max"
  data: z.array(TimeseriesPointSchema),
});
export type TimeseriesSubLine = z.infer<typeof TimeseriesSubLineSchema>;

// Each individual measurement in time
export const ReferenceSchema = z.object({
  name: z.string(),
  label: z.string(),
  value: z.number(),
});
export type Reference = z.infer<typeof ReferenceSchema>;

// One ID’s overall line of data (which may now hold multiple sub-lines)
export const TimeseriesLineSchema = z.object({
  id: z.string(),
  fullFrontendID: z.string(),
  idStatus: AlertStatusSchema,
  references: z.array(ReferenceSchema).optional(),
  // Instead of a single array of data points, we have multiple possible lines
  subLines: z.array(TimeseriesSubLineSchema),
});
export type TimeseriesLine = z.infer<typeof TimeseriesLineSchema>;

// A specific metric, holding its own status plus multiple ID lines
export const TimeseriesMetricSchema = z.object({
  metricName: z.string(),
  metricStatus: AlertStatusSchema,
  references: z.array(ReferenceSchema).optional(),
  lines: z.array(TimeseriesLineSchema),
});
export type TimeseriesMetric = z.infer<typeof TimeseriesMetricSchema>;

// Top-level container with multiple metrics
export const TimeseriesDataSchema = z.object({
  metrics: z.array(TimeseriesMetricSchema),
});
export type TimeseriesData = z.infer<typeof TimeseriesDataSchema>;
